<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode" class="title">{{$t('clients.NouveauClient')}}</span>
    <span v-if="isEditionMode" class="title">{{$t('clients.EditCustomer')}}</span>
  </span>
  <el-row :gutter="20" style="margin-bottom:20px;">
    <el-col>
      <el-steps :active="step" align-center>
        <el-step icon="el-icon-office-building"></el-step>
        <el-step icon="el-icon-location-information"></el-step>
        <el-step icon="el-icon-user" :disabled="true" v-if="isCompany"></el-step>
        <el-step icon="el-icon-setting"></el-step>
      </el-steps>
    </el-col>
  </el-row>
  <el-divider />
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">

        <!-- Information générale du Client -->
        <div v-show="step==0">

          <el-row :gutter="20" justify="center">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-radio-group v-if="isCreationMode" v-model="typeModel" @change="resetForm();">
          			<el-radio  label="1" border >{{$t('clients.types.corporatif')}}</el-radio>
          			<el-radio  label="0" border >{{$t('clients.types.individuel')}}</el-radio>
          		</el-radio-group>
            </el-col>
          </el-row>
          <el-divider />
          <h4>{{$t('clients.infos')}}</h4>
          <!-- Information générale de client corporatif -->
          <div v-if="isCompany">
            <el-form ref="companyInfoForm" :model="company" :rules="rules.corporate" style="max-width:1000px;" label-position="top">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-tooltip class="item" effect="dark" :content="$t('clients.companyNameTooltip')" placement="top-start">
                    <el-form-item prop="name" :label="$t('clients.companyName')">
                        <el-input v-model="companyName" @change="setUsualNameIfNotSet"></el-input>
                    </el-form-item>
                  </el-tooltip>
               </el-col>
               <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-tooltip class="item" effect="dark" :content="$t('clients.usualNameTooltip')" placement="top-start">
                  <el-form-item :label="$t('clients.companyUsualName')">
                     <el-input v-model="companyUsualName"></el-input>
                 </el-form-item>
                </el-tooltip>
               </el-col>
             </el-row>
             <el-row :gutter="20">
               <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                 <el-form-item prop="email" :label="$t('clients.companyEmail')">
                   <el-input v-model="companyEmail" placeholder="info@cie.com" suffix-icon="el-icon-message"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                 <el-form-item :label="$t('clients.companyPhone')">
                   <PhoneComponent :data="{phone : ciePhoneNumber, ext :ciePhoneExt}" @updatePhone=" v=> ciePhoneNumber=v" @updateExt=" v=> ciePhoneExt=v"></PhoneComponent>
                 </el-form-item>
               </el-col>
             </el-row>
             <el-row>
                 <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                   <el-form-item :label="$t('clients.groupedUnderCsutomer')">
                     <SelectCustomer :customer="parent" @selected=" v=> setParent(v)"></SelectCustomer>
                   </el-form-item>
                 </el-col>
             </el-row>
           </el-form>
          </div>
          <!-- Information générale de client individuel -->
          <div v-show="isIndividual">
            <el-form ref="individualInfoForm" :model="contact" :rules="rules.individual" style="max-width:1000px;" label-position="top">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item prop="sex" :label="$t('contacts.gender')">
                    <el-radio-group v-model="sex" size="medium">
                      <el-radio-button label="1">{{$t('contacts.genderMale')}}</el-radio-button>
                      <el-radio-button label="0">{{$t('contacts.genderFemale')}}</el-radio-button>
                      <el-radio-button label="2">{{$t('contacts.genderOther')}}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item prop="title" :label="$t('contacts.contactTitleField')">
                    <el-select v-model="denomination" :placeholder="$t('contacts.chooseTitle')" value-key="id">
                      <el-option
                        v-for="item in denominations"
                        :key="item.id"
                        :label="item.name[lang]"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item prop="first_name" :label="$t('contacts.firstName')">
                    <el-input v-model="first_name"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item prop="last_name" :label="$t('contacts.lastName')">
                    <el-input v-model="last_name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item prop="email" :label="$t('contacts.emailField2')">

                    <el-input v-model="email"  suffix-icon="el-icon-message" @change="validateEmail"></el-input>
                    <slot scope="error">
                      <span v-if="emailError"><i class="el-icon-warning"></i> {{emailError}}</span>

                    </slot>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item :label="$t('contacts.phoneField2')">
                    <PhoneComponent :data="{phone : phoneNumber, ext :phoneExt}" @updatePhone=" v=> phoneNumber=v" @updateExt=" v=> phoneExt=v"></PhoneComponent>
                    <!-- <el-input v-model="phoneNumber" suffix-icon="el-icon-phone"></el-input> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <h4>{{ $t('clients.repAndTerritory') }}</h4>
          <el-form ref="territory">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('clients.territory')">
                  <el-select v-model="territoryModel"  @change="onTerritoryChange" value-key="id" clearable>
                    <el-option
                      v-for="t in territories"
                      :key="t.id"
                      :label="t.code"
                      :value="t">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('clients.rep')">
                  <el-select v-model="rep" clearable>
                    <el-option
                      v-for="u in filterUserWithRoleRep"
                      :key="u.id"
                      :label="u.firstName + ' ' + u.lastName"
                      :value="u.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <h4>{{ $t('clients.personnalizedFiled') }}</h4>
          <el-form ref="customFields">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <el-form-item  :label="$t('clients.externalId')">
                    <el-input v-model="externalIdModel"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- Adresse du client -->
        <div v-if="step==1">
          <h4>{{$t('common.addresses.Addresses')}}</h4>
          <div style="text-align:center;margin-bottom:20px;" v-if="addresses.length==0"><span class="secondary-text fs-14">{{ $t('clients.noAddresses') }}</span></div>
          <el-col v-for="(address, index) in addresses" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:5px;">
             <AddressCard :address="address" :index="index" @remove="removeAddress" @change="updateAddress" @clickToAdd="disableCtrl" @cancel="enableCtrl"></AddressCard>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top:10px;margin-bottom:10px;">
            <AddressFlatEditor @add="addAddress" :addressToEdit="addressToEdit" @clickToAdd="disableCtrl" @cancel="enableCtrl"></AddressFlatEditor>
          </el-col>
        </div>
        <!-- Contacts du client (Corporatif seulement -->
        <div v-if="step==2">
          <el-form ref="contactForm">
            <el-row :gutter="20" justify="center">
              <el-col>
                <el-alert
                   style="word-break:break-word;"
                   :title="$t('clients.newCompanyContactInstruction')"
                   type="info"
                   show-icon>
                 </el-alert>
              </el-col>
            </el-row>
            <el-row :gutter="20" justify="center" style="margin-top:20px;">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('clients.searchCompanyContact')">
                  <ContactPicker @select="handleSelectContact"></ContactPicker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item style="text-align:center;">
                  <div class="hidden-md-and-down" style="margin-top:40px;"/>
                  <el-button type="primary" @click="openContactEditor" >{{$t('clients.createContact')}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <h4>{{$t('clients.contactAssociated')}}</h4>
              <div v-for="(c, index) in company.contacts" :key="index" style="margin-bottom:10px;">
                <CompanyContactFlatEditor :contact="c" :index="index" @remove="removeCompanyContact(index)"></CompanyContactFlatEditor>
              </div>
              <div v-if="company.contacts.length==0" style="text-align:center;">
                <span>{{ $t('clients.noCompanyContact') }}</span>
              </div>
          </el-row>
          </el-form>
          <contactEditor :visible="showContactEditor" @created="addNewContact" @close="closeContactEditor"></contactEditor>
        </div>
        <!-- Configuration du client -->
        <div v-if="step==3">
          <CustomerSettings :customerId="customerToEditId" :listTags="listTags"></CustomerSettings>
        </div>

    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button v-if="step>0" type="primary" @click="previousStep" :disabled="ctrlDisabled"><i class="el-icon-back"/></el-button>
    <el-button @click="close">{{$t('common.Cancel')}}</el-button>
    <el-button v-if="!isEditionMode && step==3" type="primary" @click="save" :disabled="ctrlDisabled || saving === true">{{$t('common.confirm')}}</el-button>
    <el-button v-if="isEditionMode && step==3" type="primary" @click="save" :disabled="ctrlDisabled || saving === true">{{$t('common.Edit')}}</el-button>
    <el-button v-if="step<3" type="primary" @click="nextStep" :disabled="ctrlDisabled"><i class="el-icon-right"/></el-button>
  </span>
  </el-dialog>
</template>
<script>
import AddressCard from '@/components/address/Address-Card'
import AddressFlatEditor from '@/components/address/Address-Flat-Editor'
import ContactEditor from '@/components/contact/contact-editor'
import ContactPicker from '@/components/contact/Contact-picker'
import CompanyContactFlatEditor from '@/components/contact/Company-contact-flat-editor'
import CustomerSettings from '@/components/customer/Customer-settings'
import SystemApi from '@/services/API/system'
import PhoneComponent from '@/components/phone.vue'
import PortausAdminAPI from '@/services/API/portaus-admin'
import axios from 'axios'
import SelectCustomer from '@/components/customer/select-customer'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'CustomerEditor',
	props: {
		visible : Boolean,
    customerToEdit : Object,
	},
  data() {
    return {
      saving: false,
      listTags : [],
      denominations : [],
      step : 0,
      fullScreenLoading : false,
      emailError : null,
      rules : {
  	  	corporate : {
  	  		name : [
  	  		 	{ required: true, message: 'Veuillez saisir un nom de compagnie', trigger: 'blur' }
  	  		],
  	  		email : [
  	  			{ type: 'email', message: "Format de l'adresse courriel incorrect", trigger: ['blur', 'change'] }
  	  		],
  	  	},
  	  	individual : {
  	  		first_name : [
  	  			{ required: true, message: 'Veuillez saisir un prénom', trigger: 'blur' }
    			],
  	  		// last_name : [
  	  		// 	{ required: true, message: 'Veuillez saisir un nom', trigger: 'blur' }
  	  		// ],
  	  		email : [
  	  			// { required: true, message: 'Veuillez saisir un courriel', trigger: 'blur' },
  	  			{ type: 'email', message: "Format de l'adresse courriel incorrect", trigger: ['blur', 'change'] }
  	  		]
  	  	}
  	  },
      addressToEdit : null,
      showContactEditor : false,
    };
  },components: {
    AddressFlatEditor,
    AddressCard,
    ContactEditor,
    ContactPicker,
    CompanyContactFlatEditor,
    CustomerSettings,
    PhoneComponent,
    SelectCustomer
  },
	methods: {
    fetchDenominations(){
      return PortausAdminAPI.fetchDenominations()
        .then((denominations) =>  {
          this.denominations = denominations
        })
    },
    addCurrentTagIfNotPresent(listTags, currentTags){
      _.forEach(currentTags, t=>{
        let tagFound = _.find(listTags, t2=>{return t2.code==t.code});
        if(tagFound==null){
          this.listTags.push(t);
        }
      })
    },
    fetchCustomerTags(){
      return SystemApi.getTags('CUSTOMER',true)
        .then(tags=>{
          this.listTags=tags;
        })
    },
    validateEmail(){

      let params = {email:this.email}

      if(this.email!=null && this.email!=''){
        return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/validate-email", {params})
          .then(()=>{
            this.emailError = null;
          }).catch(err=>{
            this.emailError = "Un contact existe déjà avec cette adresses courriel"
          })
      }

    },
    open(){
      this.step=0;
      this.enableCtrl();
      if(this.isEditionMode){
          this.cloneCustomerForEdition(this.customerToEdit);
      }
      this.fetchTerritories();
      this.fetchAdminUsers();
      this.fetchCustomerTags()
        .then(()=>{
          if(this.customerToEdit!=null){
            this.addCurrentTagIfNotPresent(this.listTags, this.customerToEdit.tags);
          }
        })
    },
    addNewContact(contact){
      this.closeContactEditor();
      this.addCompanyContact(contact);
    },
    handleSelectContact(contact){
      this.addCompanyContact(contact);
    },
    openContactEditor(){
      this.showContactEditor=true;
    },
    closeContactEditor(){
      this.showContactEditor=false;
    },
    close(){
      this.$emit('close');
      this.resetAll();
      this.step=0;
      this.setType('1')
    },
    resetForm() {
			if(this.$refs.companyInfoForm!=null){
				this.$refs.companyInfoForm.resetFields();
        this.resetCustomerInfo();
			}
			if(this.$refs.individualInfoForm!=null){
				this.$refs.individualInfoForm.resetFields();
				this.resetCustomerInfo();
			}

  	},
    nextStep(){
      this.fullScreenLoading=true;
      if(this.step==0){
        this.validateStep0()
          .then(valid=>{
            if(valid)this.step++;
            this.fullScreenLoading=false;
          }).catch(notValid=>{
            this.fullScreenLoading=false;
          })
      }else{
        //L'étape 2 n'exsite pas pour un client individuel
        if(this.step==1 && this.isIndividual){
          this.step++;
        }
        if(this.step>1 && !this.isEditionMode){
            this.fetchDefaultCustomerSettings();
        }
        this.step++;
        this.fullScreenLoading=false;
      }
    },
    previousStep(){
      if(this.step==3 && this.isIndividual){
        this.step--;
      }
      this.step--;
    },
    validateStep0(){
      if(this.isCompany){
        return this.$refs['companyInfoForm'].validate();
      }else{
        return this.$refs['individualInfoForm'].validate();
      }
    },
    save(){
      this.saving = true;
      if (this.settings.reservationNotificationInd == true &&
         (this.settings.reservationNotificationType == null ||
          this.settings.reservationNotificationEmailCustomContent == null)) {
            this.$message.error("Vous devez spécifier la fréquence et le courriel personnalisé pour le rappel de réservations et commandes");
            return null;
      }


      let action = this.isEditionMode?"UPDATE":"CREATE";
      return this.saveCustomer(action)
        .then(customer=>{
          if(customer!=null){
            if(this.isEditionMode){
              this.$emit('updated',customer )
            }else{
              this.$emit('created', customer);
            }
            this.close();
            this.saving = false;
            // this.openCustomer(customer.id)

          }

        }).catch(err=>{
          this.saving = false;
          var message = "";
          if(err.response.status == 403){
            message = this.$i18n.t("errors."+err.response.data.jse_info.errorCode);
          }else{
            message = "Erreur système. Veuillez réessayer plus tard."
          }
          this.$message.error(message);
        })

    },
    onTerritoryChange(territory){
        this.rep = territory.rep_id;
    },
    openCustomer(customerId){
      var index = '/customers/' + customerId;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
    },
    ...mapActions('controlData', ['fetchTerritories','enableCtrl']),
    ...mapActions('customerEditor',['setCorporateCustomerProp','setIndividualCustomerProp','setType','setUsualNameIfNotSet','resetCustomerInfo','disableCtrl','enableCtrl','addAddress','updateAddress','removeAddress','addCompanyContact','removeCompanyContact','fetchDefaultCustomerSettings','resetAll','saveCustomer','cloneCustomerForEdition','setRep','setTerritory', 'setParent', 'setExternalId']),
    ...mapGetters('customerEditor',['companyCustomerPhoneNumber','individualCustomerPhoneNumber']),
    ...mapActions('users',['fetchAdminUsers'])
	},
	computed: {
    lang(){
      return this.$i18n.locale
    },
    isEditionMode(){
      return this.customerToEdit!=null;
    },
    isCreationMode(){
      return this.customerToEdit==null;
    },
    externalIdModel : {
      set(externalId) {this.setExternalId(externalId)},
      get(){return this.externalId}
    },
    parent : {
      set(parent){this.setParent(parent)},
      get(){return this.parent;}
    },
    territoryModel : {
      set(territory){this.setTerritory(territory)},
      get(){return this.territory;}
    },
    rep : {
      set(rep_id){this.setRep(rep_id)},
      get(){return this.rep_id;}
    },
    typeModel : {
      set(type){this.setType(type)},
      get(){return this.type}
    },
    companyName : {
      set(name){this.setCorporateCustomerProp({name})},
      get(){return this.company.name}
    },
    companyUsualName : {
      set(usual_name){this.setCorporateCustomerProp({usual_name})},
      get(){return this.company.usual_name}
    },
    companyEmail : {
      set(email){this.setCorporateCustomerProp({email})},
      get(){return this.company.email}
    },
    ciePhoneNumber: {
			set(phone){this.setCorporateCustomerProp({phone})},
      get(){return this.companyCustomerPhoneNumber()}
		},
    ciePhoneExt: {
			set(phoneExt){this.setCorporateCustomerProp({phoneExt})},
      get(){return this.company.phoneExt}
		},
		phoneNumber: {
      set(phone){this.setIndividualCustomerProp({phone})},
      get(){return this.individualCustomerPhoneNumber()}
		},
    phoneExt: {
      set(phoneExt){this.setIndividualCustomerProp({phoneExt})},
      get(){return this.contact.phoneExt;}
		},
    sex: {
      set(sex){this.setIndividualCustomerProp({sex})},
      get(){return this.contact.sex;}
		},
    denomination: {
      set(denomination){this.setIndividualCustomerProp({denomination})},
      get(){return this.contact.denomination;}
		},
    first_name: {
      set(first_name){this.setIndividualCustomerProp({first_name})},
      get(){return this.contact.first_name}
		},
    last_name: {
      set(last_name){this.setIndividualCustomerProp({last_name})},
      get(){return this.contact.last_name}
		},
    email: {
      set(email){this.setIndividualCustomerProp({email})},
      get(){return this.contact.email}
		},
    customerToEditId(){
      if(this.customerToEdit!=null){
        return this.customerToEdit.id;
      }
    },
    ...mapState('customerEditor', ['type','company', 'contact','addresses','ctrlDisabled','territory', 'rep_id', 'parent', 'settings', 'externalId']),
    ...mapGetters('customerEditor',['isCompany','isIndividual']),
    ...mapState('controlData',['territories']),
    ...mapGetters('users',['filterUserWithRoleRep'])
	},
  mounted(){
    this.fetchDenominations();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

// .el-input__inner{
//   border:0px;
// }

.title {
	font-size : 1.6em;
	font-weight:bold;

}

.formContainer{
    margin-left:15%;
    width:70%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}
</style>
